import { ArrowUpRight } from "lucide-react";
import { WHATSAPP_HREF } from "@/lib/ascentix";

export default function Mission() {
  return (
    <section
      data-testid="mission-section"
      className="relative py-24 md:py-32 overflow-hidden bg-slate-900"
    >
      {/* Mission visual as soft background */}
      <div className="absolute inset-0">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/78fd9583-1bdd-4788-b569-9ee7023a9208/images/3972ab38f5cc2a75f9e1ca72f85caf5d438ffdca9195af1674d6e43e5eadc942.png"
          alt=""
          className="w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/85 to-slate-900/40" />
      </div>

      {/* Subtle peaks SVG accent */}
      <div className="absolute right-0 bottom-0 w-[60%] h-full pointer-events-none opacity-30">
        <svg viewBox="0 0 600 600" className="w-full h-full">
          <defs>
            <linearGradient id="m1" x1="0" y1="1" x2="0" y2="0">
              <stop offset="0%" stopColor="#f59e0b" />
              <stop offset="100%" stopColor="#ea580c" />
            </linearGradient>
          </defs>
          <polygon
            points="300,120 540,560 60,560"
            fill="url(#m1)"
            opacity="0.18"
          />
          <polygon
            points="300,200 480,560 120,560"
            fill="url(#m1)"
            opacity="0.32"
          />
          <polygon
            points="300,280 420,560 180,560"
            fill="url(#m1)"
            opacity="0.55"
          />
        </svg>
      </div>

      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10 lg:px-16">
        <div className="max-w-3xl reveal">
          <span className="eyebrow !text-amber-400">Our Mission</span>
          <h2
            data-testid="mission-headline"
            className="font-display mt-5 text-4xl md:text-6xl lg:text-[68px] leading-[1.05] text-white"
          >
            Transforming managers into{" "}
            <span className="text-amber-400">strategic enablers</span> of
            growth.
          </h2>
          <p className="mt-7 text-[18px] md:text-[20px] leading-relaxed text-amber-50/80 max-w-[700px]">
            Our mission is to transform managers and professionals into
            strategic enablers of operational excellence, regulatory agility
            and customer-centred growth.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <a
              href={WHATSAPP_HREF}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mission-cta-whatsapp"
              className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-orange-600 hover:bg-orange-700 text-white font-semibold shadow-[0_14px_30px_-10px_rgba(234,88,12,0.7)]"
            >
              Start the conversation
              <ArrowUpRight className="size-4" />
            </a>
            <button
              onClick={() =>
                document
                  .getElementById("contact")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              data-testid="mission-cta-form"
              className="inline-flex items-center gap-2 h-12 px-5 rounded-full border border-white/20 text-amber-50 hover:border-amber-400 hover:text-amber-300 transition-colors"
            >
              Send an enquiry
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
